import React from "react";
import { CustomerQuotes } from "./data";

const CustomerQuotesSection = () => {
  return (
    <div
      style={{
        background: 'url("/static/img/platform-background.png")',
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
      className="text-white flex flex-col items-center pb-14 pt-8 gap-5 md:px-20 lg:px-32 relative before:content-[''] before:absolute before:top-0 before:left-0 before:w-full before:h-10 before:bg-gradient-to-b before:from-[#0C0F14] before:to-transparent after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-full after:h-10 after:bg-gradient-to-t after:from-[#0C0F14] after:to-transparent"
    >
        <div className="text-white text-[32px] md:text-[42px] lg:text-[52px] xl:text-[62px] font-bold">
        User Testimonials
      </div>
      <div className="slider-container overflow-hidden w-full">
        <div className="slider-content-wrapper inline-flex whitespace-nowrap animate-marquee">
          <div className="flex items-center gap-16 px-8">
            {CustomerQuotes.map((customer, index) => (
              <div
                key={index}
                className="w-[500px] h-[300px] shrink-0 bg-[rgba(12,15,20,0.8)] backdrop-blur-md rounded-xl p-8 border border-[rgba(255,255,255,0.05)] items-center flex flex-col justify-center"
              >
                <div className="text-[18px] font-medium text-center mb-4 w-full">
                  <p className="leading-[1.6]">
                    {customer.text}
                  </p>
                </div>
                <div className="flex gap-2 justify-center mb-4">
                  {new Array(customer.star).fill(0).map((_, index) => (
                    <img
                      src="/static/img/icons/star-blue-fill.svg"
                      alt="star"
                      key={index}
                    />
                  ))}
                </div>
                <div className="flex flex-col text-center">
                  <span className="text-[18px] font-bold">{customer.name}</span>
                  {customer?.title?.length &&
                    customer.title.map((title, index) => (
                      <div key={index} className="text-[18px]">
                        {title}
                      </div>
                    ))}
                </div>
              </div>
            ))}
          </div>
          <div className="flex items-center gap-16 px-8">
            {CustomerQuotes.map((customer, index) => (
              <div
                key={index}
                className="w-[500px] h-[300px] shrink-0 bg-[rgba(12,15,20,0.8)] backdrop-blur-md rounded-xl p-8 border border-[rgba(255,255,255,0.05)] items-center flex flex-col justify-center"
              >
                <div className="text-[18px] font-medium text-center mb-4 w-full">
                  <p className="leading-[1.6]">
                    {customer.text}
                  </p>
                </div>
                <div className="flex gap-2 justify-center mb-4">
                  {new Array(customer.star).fill(0).map((_, index) => (
                    <img
                      src="/static/img/icons/star-blue-fill.svg"
                      alt="star"
                      key={index}
                    />
                  ))}
                </div>
                <div className="flex flex-col text-center">
                  <span className="text-[18px] font-bold">{customer.name}</span>
                  {customer?.title?.length &&
                    customer.title.map((title, index) => (
                      <div key={index} className="text-[18px]">
                        {title}
                      </div>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <style>{`
        .slider-container {
          mask-image: linear-gradient(
            to right,
            transparent 0%,
            black 10%,
            black 90%,
            transparent 100%
          );
          -webkit-mask-image: linear-gradient(
            to right,
            transparent 0%,
            black 10%,
            black 90%,
            transparent 100%
          );
        }
        
        @keyframes marquee {
          from {
            transform: translate3d(0, 0, 0);
          }
          to {
            transform: translate3d(-50%, 0, 0);
          }
        }
        
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default CustomerQuotesSection;
